import * as React from "react";


export const columns =
    [

        {
            field: "date",
            label: "Data wydania",
            sort: "desc",
            width: 53
        },
        {
            field: "username",
            label: "Użytkownik wydał",
            sort: "desc",
            width: 53
        },
        {
            field: "comment",
            label: "Komentarz",
            sort: "desc",
            width: 53
        },

        {
            field: "operationQuantity",
            label: "Ile wydał",
            sort: "desc",
            width: 53,
        }
    ]
;


export default columns;